import Highcharts from 'highcharts';
import { registerHighchartsErrorLogger } from './registerHighchartsErrorLogger';

registerHighchartsErrorLogger(Highcharts);

// Allow custom data attributes used in HTML formatters without triggering Highcharts warnings.
const allowedAttributes = Highcharts.AST?.allowedAttributes;
if (allowedAttributes) {
  const customAttributes = ['data-id', 'data-name', 'dir'];
  customAttributes.forEach(attr => {
    if (!allowedAttributes.includes(attr)) {
      allowedAttributes.push(attr);
    }
  });
}

export {}; // side-effect only module

const originalAttr = Highcharts.SVGElement.prototype.attr;

(Highcharts.SVGElement.prototype as any).attr = function patchedAttr(this: Highcharts.SVGElement, ...args: any[]) {
  const invokeOriginal = (innerArgs: any[]) =>
    (originalAttr as typeof Highcharts.SVGElement.prototype.attr).apply(this, innerArgs as any);

  const sanitize = (value: number) => {
    if (typeof value !== 'number' || value >= 0) {
      return value;
    }

    if (value > -0.5) {
      return 0;
    }

    const chart = (this as any).renderer?.chart as Highcharts.Chart | undefined;
    const options = chart?.options as Highcharts.Options & { custom?: Record<string, unknown> };
    const customMeta = options?.custom;
    // eslint-disable-next-line no-console
    console.error('[Highcharts negative height]', {
      value,
      elementId: (this as any).element?.id,
      elementClass: (this as any).element?.className?.baseVal,
      chartId: options?.chart && 'id' in options.chart ? (options.chart as { id?: string }).id : undefined,
      chartCustom: customMeta,
      chartTitle: options?.title?.text,
    });

    return 0;
  };

  const argsCopy = Array.isArray(args) ? [...args] : [];

  if (argsCopy.length === 2) {
    const [key, value] = argsCopy;
    if (key === 'height') {
      argsCopy[1] = sanitize(value);
    }
  } else if (argsCopy.length === 1 && argsCopy[0] && typeof argsCopy[0] === 'object') {
    const hash = { ...(argsCopy[0] as Record<string, unknown>) };
    if (hash.height !== undefined) {
      hash.height = sanitize(hash.height as number);
    }
    argsCopy[0] = hash;
  }

  try {
    return invokeOriginal(argsCopy);
  } catch (error) {
    if (argsCopy.length === 2 && argsCopy[0] === 'height') {
      const retryArgs: any[] = [argsCopy[0], sanitize(0)];
      return invokeOriginal(retryArgs);
    }

    if (
      argsCopy.length === 1 &&
      argsCopy[0] &&
      typeof argsCopy[0] === 'object' &&
      (argsCopy[0] as Record<string, unknown>).height !== undefined
    ) {
      const retryHash = { ...(argsCopy[0] as Record<string, unknown>), height: 0 };
      return invokeOriginal([retryHash]);
    }

    throw error;
  }
};
